import React, { useState, useEffect } from "react";
import OTPInput from "react-otp-input";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const OtpEmail = ({
  id_R,
  otpEmailOpen,
  setOtpEmailOpen,
  otp,
  setOtp,
  handleOtpVerification,
  setIsNewEmailOpen,
  newEmail,
  timer,
  setTimer,
  handleReTimer,
}) => {
  const [isOtpValid, setIsOtpValid] = useState(false);
  useEffect(() => {
    if (!otpEmailOpen) return;

    const intervalId = setInterval(() => {
      setTimer((prevSeconds) => {
        if (prevSeconds <= 1) {
          clearInterval(intervalId);
          return 0;
        }

        return prevSeconds - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [otpEmailOpen, timer]);

  const handleClose = () => {
    setOtpEmailOpen(false);
  };

  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
    setIsOtpValid(newOtp.length === 6);
  };

  const handleBackButton = () => {
    handleClose();
    setIsNewEmailOpen(true);
  };

  return (
    <SlidePanel isOpen={otpEmailOpen} onClose={handleClose}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        <div
          onClick={handleClose}
          className="absolute top-0 right-0 cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center z-10"
        >
          <X color="#ffffff" />
        </div>
        <div className="flex flex-col h-full">
          <div className="p-[20px]">
            <div className="flex items-center">
              <p className="text-[20px] font-bold text-[#000] mt-8">
                Verify email
              </p>
            </div>

            <p className="text-[#000] text-[15px] mt-3">
              Enter OTP code sent to the email you entered.
            </p>

            <div className="flex flex-col items-center h-[65vh] mt-20">
              <p className="text-[#000] font-[300] text-[15px]">
                An OTP has been sent to the email: {newEmail}
              </p>

              <div className="flex flex-col mt-20">
                <label
                  htmlFor="firstname"
                  className="mb-[20px] text-[#000000] font-[500]"
                >
                  Email verification OTP
                </label>

                <div className="flex flex-col ">
                  <div>
                    <OTPInput
                      value={otp}
                      onChange={handleOtpChange}
                      numInputs={6}
                      onPaste={true}
                      renderInput={(props) => (
                        <input
                          {...props}
                          style={{ width: "45px", height: "45px" }}
                        />
                      )}
                      renderSeparator={<span className="mx-2" />}
                      inputStyle="bg-white text-[20px] text-center text-[24px] text-[#000] border-[1px] border-[#000] rounded-[5px]"
                    />
                  </div>

                  <div className="mt-[20px] flex justify-between items-center">
                    <p className="text-[#074073] text-[14px]">
                      Didn’t receive a code?
                    </p>

                    {timer === 0 ? (
                      <p
                        className="cursor-pointer text-[#074073] text-[14px]"
                        onClick={handleReTimer}
                      >
                        Resend
                      </p>
                    ) : (
                      <p className="text-[#074073] text-[14px]">
                        Resend in
                        <span className="ml-2">
                          00:{timer < 10 ? `0${timer}` : timer}
                        </span>
                      </p>
                    )}
                  </div>
                </div>
              </div>

              <div className="flex items-end w-full mx-auto h-[35vh] text-white justify-between">
                <button
                  onClick={handleBackButton}
                  className="h-[50px] w-[175px] bg-[#7FB8EA] rounded-[5px] text-[#000]"
                >
                  Back
                </button>

                <button
                  onClick={handleOtpVerification}
                  className={`h-[50px] w-[175px] rounded-[5px] transition-all duration-200 ${
                    isOtpValid
                      ? "bg-[#074073] cursor-pointer"
                      : "bg-[#D9D9D9] cursor-not-allowed"
                  }`}
                  disabled={!isOtpValid}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default OtpEmail;
